import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { ONBOARDING_ROUTES, ROUTES, insertIdtoUrl } from 'constants/Routes';
import { getBusinessId } from 'constants/localStorageManager';
import OnboardingModal from './index';

const FinishTour = ({ path, history, enableHeaderExit }) => {
  const [isVisible, toggleModal] = useState(path === ONBOARDING_ROUTES.STEP_FOUR);
  const handleContinue = () => {
    toggleModal(!isVisible);
    enableHeaderExit();
    const pushUrl = insertIdtoUrl(ROUTES.REPORT_LIST, getBusinessId);
    history.push(pushUrl);
  }

  return (
    <OnboardingModal
      isVisible={isVisible}
      handleContinue={handleContinue}
      buttonText={"Finish Guided Tour"}
      finishModal
    >
      <h2>Gain Actionable insights</h2>
      <p>
        Here is where you will find your survey data. There's not much here yet but make sure to come back as soon as you start collecting survey responses.
      </p>
      <div className="card p-3 styled-box-shadow">
        <p>
          Need help collecting survey responses? Check out our resources site where you'll find tips, tricks, and best practices for engaging your customers.
        </p>
        <div>
          <h5>Quick Links <FontAwesomeIcon icon="external-link-alt" /></h5>
          <ul className="onboarding-modal-list list-border-bottom">
            <li>
              <FontAwesomeIcon icon="check-circle" className="text-success" />
              <a
                href="https://resources.mysoono.com/getting-started/soono-quick-start-guide/"
                target="_blank"
              >
                Soono quick start guide
              </a>
            </li>
            <li>
              <FontAwesomeIcon icon="check-circle" className="text-success" />
              <a
                href="https://resources.mysoono.com/how-tos/how-to-use-soono-survey-placards/"
                target="_blank"
              >
                How to use Soono Survey Placards
              </a>
            </li>
            <li>
              <FontAwesomeIcon icon="check-circle" className="text-success" />
              <a
                href="http://resources.mysoono.com/2019/11/20/4-tips-to-increase-survey-participation/"
                target="_blank"
              >
                4 Tips on how to increase survey participation
              </a>
            </li>
            <li>
              <FontAwesomeIcon icon="check-circle" className="text-success" />
              <a
                href="https://resources.mysoono.com/2019/11/20/why-you-should-incentivize-customers-to-take-your-survey/"
                target="_blank"
              >
                Why you should incentivize customers to take your survey
              </a>
            </li>
            <li>
              <FontAwesomeIcon icon="check-circle" className="text-success" />
              <a
                href="https://resources.mysoono.com/2019/12/02/5-great-ideas-on-where-to-put-your-surveys-qr-code/"
                target="_blank"
              >
                5 Great Ideas on Where to Put Your Surveys QR Code
              </a>
            </li>
          </ul>
        </div>
      </div>
    </OnboardingModal >
  );
};

FinishTour.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func
};

export default FinishTour;



// WEBPACK FOOTER //
// ./src/components/Onboarding/Modal/FinishTour.js